import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import compact from 'lodash/compact';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import toUpper from 'lodash/toUpper';
const Initials = ({ name, className })=>{
    if (!name || isEmpty(name)) {
        return null;
    }
    const initials = [];
    if (!isArray(name)) {
        name = name.split(' ');
    }
    const cname = compact(name);
    for(let i = 0; i < Math.min(2, cname.length); i++){
        initials.push(toUpper(cname[i][0]));
    }
    return /*#__PURE__*/ _jsx("div", {
        className: cn('avatar__initials', className),
        children: initials.join('')
    });
};
export default Initials;
